import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, IconButton, Box, Button, Badge } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import axios from '../../api/axiosClient';
import Menu from '../Menu/Menu'; // Убедитесь, что путь к файлу Menu верный
import { useCart } from '../Cart/CartContext';
import api from '../Composition/api'; // Импорт функций API

const Header = () => {
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const handleCartClick = () => {
    navigate('/cart'); // Перенаправляем пользователя на страницу корзины
  };
  const [searchOpen, setSearchOpen] = useState(false); // Состояние для отображения строки поиска
  const [searchQuery, setSearchQuery] = useState(''); // Состояние для хранения запроса
  const [categories, setCategories] = useState([]); // Состояние для хранения категорий
  const [categoriesError, setCategoriesError] = useState('');
  const [searchError, setSearchError] = useState('');

  const handleLogoClick = () => {
    navigate('/'); // Перенаправляем пользователя на главную страницу
  };

  const handleDrawerClose = () => {
    setMenuOpen(false);
  };

  const { cartCount, setCartCount } = useCart();

  useEffect(() => {

    const fetchCategories = async () => {
      try {
        const response = await axios.get('/api/parent-categories/');
        setCategories(response.data);
        setCategoriesError('');
      } catch (error) {
        setCategoriesError('Не удалось загрузить категории.');
      }
    };
    fetchCategories();


    const fetchCartCount = async () => {
      try {
        const count = await api.fetchCartCount();
        setCartCount(count);
      } catch (error) {
        // количество товаров в корзине не критично для рендера страницы
      }
    };
    fetchCartCount();
  }, [setCartCount]);

  const handleSearchSubmit = async () => {
    if (!searchQuery.trim()) return;
    try {
      const response = await axios.get(`/api/search/?q=${encodeURIComponent(searchQuery)}`);
      setSearchError('');
      navigate(`/search-results?q=${encodeURIComponent(searchQuery)}`, { state: { results: response.data } });
      setSearchOpen(false); // Скрываем строку поиска после выполнения поиска
    } catch (error) {
      setSearchError('Не удалось выполнить поиск. Попробуйте ещё раз.');
    }
  };



  return (
    <AppBar position="sticky" sx={{ backgroundColor: 'lightpink', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', pt: 1 }}>
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            
          <IconButton 
            edge="start" 
            color="inherit" 
            aria-label="menu" 
            sx={{ color: 'black', mr: 2 }} 
            onClick={() => setMenuOpen(true)}
          >
            <MenuIcon />
          </IconButton>
          <img src="/logo.png" alt="Logo" style={{ height: '50px' }} onClick={handleLogoClick} />
          <Box sx={{ display: 'flex' }}>
          {searchOpen && (
            <Box sx={{ display: 'flex', flexDirection: 'column', mr: 2 }}>
              <TextField
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') handleSearchSubmit(); }}
                placeholder="Поиск..."
                size="small"
              />
              {searchError && (
                <Box sx={{ fontSize: '0.75rem', color: 'error.main', mt: 0.5 }}>{searchError}</Box>
              )}
            </Box>
          )}
          <IconButton sx={{ color: 'black' }} onClick={() => setSearchOpen(!searchOpen)}>
            <SearchIcon />
          </IconButton>
            <IconButton sx={{ color: 'black' }} onClick={handleCartClick}>
              <Badge badgeContent={cartCount} color="error">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </Box>
        </Box>
        {categoriesError && (
          <Box sx={{ fontSize: '0.8rem', color: 'error.main', mt: 1 }}>{categoriesError}</Box>
        )}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, width: '100%', justifyContent: 'center', mt: 2 }}>
          {categories.map((category) => (
            <Button 
              key={category.id} 
              color="inherit" 
              sx={{ color: 'black', mx: 2 }}
              onClick={() => navigate(`/${category.slug}`)}
            >
              {category.name}
            </Button>
          ))}
        </Box>
      </Toolbar>
      <Menu open={menuOpen} handleDrawerClose={handleDrawerClose} />
    </AppBar>
  );
};

export default Header;
